<template>
	<div class="editorForm">
		<div v-for="(item,index) in formList" :key="index">
			<u-form :id="item.id" :ref="item.id" :label-style="labelStyle" v-model="_newSettings">
				<div v-for="(item2,index2) in item.dataList" :key="index2">
					<u-form-item :label="item2.label" :prop="item2.prop" :label-position="labelPosition">
						<editor-field :value="item2.value" :type="item2.type" :radioList="item2.radioList" 
						:selectList="item2.selectList" :varList="varList" :varJson="varJson"
						v-on:input="this.handleChange(val,item2.value)"></editor-field>
					</u-form-item>
				</div>
			</u-form>
		</div>
	</div>
</template>

<script>
	import editorField from "./EditorField";
	export default {
		name: 'editorForm',
		props: {
			formList: Array,
			ruleList: Array,
			varList: Array,
			varJson: Object,
			labelPosition: String,
			labelStyle: Object,
			newSettings: Object,
		},
		data(){
			return{
				
			}
		},
		components:{
			editorField
		},
		computed:{
			_newSettings: {
        get() {
          return this.newSettings
        },
        set(val) {
          this.$emit("input", val)
        }
			}
		},
		mounted() {
			this.init()
		},
		methods:{
			//注册表单规则,并验证
			init(){
				this.formList.forEach((item, index) => {
					this.$refs[item.id].setRules(this.ruleList[index])
				})
				return this.formList.map(item => {
					return this.$refs[item.id].validate()
				})
			},
		}
	}
</script>

<style>
</style>
